module.exports = __webpack_public_path__ + "media/svg/logo-d15962f9.svg";